import { Component, Input, ViewChild } from '@angular/core';
import { ChartComponent } from 'ng-apexcharts';
import { ChartOptions } from 'src/app/core/chart/chartOptions';
import { FlowBuilderService } from 'src/app/core/service/flow-builder.service';

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss']
})
export class LineChartComponent {
  @ViewChild("chart") chart!: ChartComponent;
  public chartOptions!: Partial<ChartOptions>;

  @Input() data:any=[]
  @Input() labels:any=[]
  @Input() colors:any=[]

  constructor(public _fb:FlowBuilderService) {}

  ngOnInit() {
    this.getCharts();
  }



  getCharts() {
    this.chartOptions = {
      series: [
        {
          name: this._fb.visualizeTitle,
          data: this.data,
        }
      ],
      chart: {
        height: 202,
        width: 800,
        type: "line",
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false,
        },
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 800,
          animateGradually: {
            enabled: true,
            delay: 150
          },
          dynamicAnimation: {
            enabled: true,
            speed: 350
          }
        },
      },
      tooltip: {
        opposite: false,
        x: {
          show: true, // Hide the x-axis value in tooltip
        },
        y: {
          formatter: (value: any) => {
            return value.toLocaleString("en-US")},
          title: {
            formatter: (_seriesName: any) => _seriesName +' '+'<strong>:</strong>'
          }
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: "straight",
        width: 3,
        colors: ['#1847df']   // Line color
      },
      grid: {
        show: false,
        column: {
          colors:  ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5
        }
      },
      markers: {
        size: 6,
        strokeWidth: 0,
        fillOpacity: 1,
        colors: ['#1847df'],  // Color of the marker
      },
      xaxis: {
        show: true,
        categories: this.labels,

      },
      yaxis: {
        show: true,
      },
    };
  }

}
